import React from "react";
import "./styles.css";

const SkipButton = ({ text, skipTo }) => {
  return (
    <div className="skip-button" onClick={skipTo}>
      {text}
    </div>
  );
};

export default SkipButton;
